import { render } from "./EmployeeCertifications.vue?vue&type=template&id=72156be0&scoped=true"
import script from "./EmployeeCertifications.vue?vue&type=script&lang=js"
export * from "./EmployeeCertifications.vue?vue&type=script&lang=js"

import "./EmployeeCertifications.vue?vue&type=style&index=0&id=72156be0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72156be0"]])

export default __exports__